const colorsConfig = {
  bgColor: "#082E56",
  color: "white",
};

export default colorsConfig;
